import { gql } from "@apollo/client";

export const ADD_DOCUMENTO_CONTRATO = gql`
    mutation addDocumentoContrato(
        $idEvaluacion: Int!,
        $documentoInput: AddDocumentoInput!,
        $documentoContratoState: Int!,
    ){
        addDocumentoContrato(
            input: {
                idEvaluacion: $idEvaluacion,
                documentoInput: $documentoInput,
                documentoContratoState: $documentoContratoState,
            }
        ) 
    }
`;